// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-bar--gradient:before{background:linear-gradient(#fff,hsla(0,0%,100%,0));content:\"\";display:block;height:2rem;left:0;pointer-events:none;position:absolute;top:100%;width:100%}.app-bar img{height:2.7rem}.v-toolbar__content{flex:1;justify-content:space-between;margin:0 4rem}.brand-name{-webkit-text-decoration:none;text-decoration:none}.navbar{z-index:10!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
